import { EventName } from '@lit/react';
import { BlocksToggle } from 'blocks-nextjs/blocks-web-components/components/toggle/toggle';
import { BlocksToggleChangeEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatToggle = createComponent({
  react: React,
  tagName: 'cat-toggle',
  elementClass: BlocksToggle,
  events: {
    onBlToggleChange: 'bl-toggle-change' as EventName<BlocksToggleChangeEvent>
  }
});
